import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import BookCallButton from '@/components/BookCallButton'

export default function Contact() {
  return (
    <section id="contact" className="relative py-32 md:py-48 bg-accent overflow-hidden">
      <div className="absolute inset-0 bg-[url('/assets/bg-noise.png')] opacity-10 mix-blend-overlay pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-accent/80 via-transparent to-accent pointer-events-none" />

      <div className="container relative z-10">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-sm font-bold text-white/80 uppercase tracking-[0.2em] mb-8">Get in Touch</h2>
          <h3 className="text-5xl md:text-8xl font-bold font-heading text-white mb-12 tracking-tight uppercase leading-[0.9]">
            Ready to <br /> <span className="text-white/90">Grow?</span>
          </h3>
          <p className="text-xl md:text-2xl text-slate-200 mb-16 max-w-2xl mx-auto font-light leading-relaxed">
            Let&apos;s talk about your next project. Strategy, marketing, design, development — we&apos;ve got you covered.
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4">
            <BookCallButton className="inline-flex items-center justify-center gap-3 group px-12 py-5 text-xl font-bold bg-white text-accent hover:bg-white/90 rounded-full shadow-[0_0_40px_-10px_rgba(255,255,255,0.3)] hover:shadow-[0_0_60px_-10px_rgba(255,255,255,0.5)] transition-all duration-500">
              Book a call
              <ArrowRight className="h-6 w-6 group-hover:translate-x-2 transition-transform duration-300" />
            </BookCallButton>
            <Link
              to="/new-project"
              className="inline-flex items-center justify-center gap-2 px-12 py-5 text-xl font-bold text-white border border-white/40 hover:bg-white/10 rounded-full transition-all duration-300"
            >
              Start a project
              <ArrowRight className="h-6 w-6" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
